import React from 'react';
import ServicePage from '../components/services/ServicePage';
import carpetMats from '../data/services/carpet-mats';

const CarpetMats: React.FC = () => <ServicePage data={carpetMats} />;

export default CarpetMats;
